var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pro-success"},[_vm._m(0),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"succ-icon"},[_c('i',{staticClass:"el-icon-success"})])
}]

export { render, staticRenderFns }